import icon from './bconnect.svg';

import type { Provider } from '../providers'

export default {
    key: 'bconnect',
    name: 'B.connect',
    color: '#ff4f00',
    btnBorderColor: 'rgba(0,0,0,.15)',
    btnTextColor: '#58666e',
    btnBackgroundColor: '#ffffff',
    icon,
} satisfies Provider;
